import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemsOverviewComponent } from './items-overview/items-overview.component';
import { CreateItemFormComponent } from './create-item-form/create-item-form.component';
import { ManageItemComponent } from './manage-item/manage-item.component';

const routes: Routes = [
  { path: 'news', component: ItemsOverviewComponent },
  { path: 'news/create', component: CreateItemFormComponent },
  { path: 'news/:id', component: ManageItemComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsRoutingModule { }
